var React = require('react');

function WindTurbine (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M350.1 480h-48.32l-5-76.66L221 314l-10.78 166H161.9a36.94 36.94 0 0 0-33 20.42A8 8 0 0 0 136 512h240a8 8 0 0 0 7.15-11.58A36.93 36.93 0 0 0 350.1 480z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M398.69 425.79l-88.35-182.32a55.77 55.77 0 0 1-.73-42.79l73.28-179.07a15.8 15.8 0 0 0-27.5-15.07L241.27 163.21a55.74 55.74 0 0 1-36.47 22.4L13.32 215.94A15.81 15.81 0 0 0 0 231.89v.23a15.8 15.8 0 0 0 14.1 15.35L203.84 268a55.77 55.77 0 0 1 37.53 20.58l130.31 153.5a15.81 15.81 0 0 0 20.53 3.63l.2-.12a15.8 15.8 0 0 0 6.28-19.8zM256 248a24 24 0 1 1 24-24 24 24 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

WindTurbine.defaultProps = {"viewBox":"0 0 514 512","className":"icon"};

module.exports = WindTurbine;

WindTurbine.default = WindTurbine;
